class QueryService {
  /* GET QUERY */
  async get(path, params, host = process.env.VUE_APP_ROOT_API) {
    const searchParams = new URLSearchParams(params);
    const url = `${host}/api/${path}.php?${searchParams}`;

    const response = await fetch(url, {
      method: "get",
      credentials: "include",
    });
    const queryResult = await response.json();
    return queryResult;
  }

  /* POST QUERY */
  async post(path, params, host = process.env.VUE_APP_ROOT_API) {
    const url = `${host}/api/${path}.php`;

    const body = new FormData();
    for (const [key, value] of Object.entries(params)) {
      body.append(key, value);
    }

    const response = await fetch(url, {
      method: "post",
      body,
      credentials: "include",
    });
    const queryResult = await response.json();
    return queryResult;
  }

  async delete(path, params, host = process.env.VUE_APP_ROOT_API) {
    const searchParams = new URLSearchParams(params);
    const url = `${host}/api/${path}.php?${searchParams}`;

    const response = await fetch(url, {
      method: "delete",
      credentials: "include",
    });
    const queryResult = await response.json();
    return queryResult;
  }
}

export const queryService = new QueryService();
